import React from 'react';

const HowItWorks = () => {
  return (
    <section className="w-full bg-surface-dark border-y border-border-dark" id="how-it-works">
      <div className="max-w-[1200px] mx-auto px-4 py-20 md:px-10">
        <div className="text-center mb-16">
          <h2 className="text-white text-3xl md:text-4xl font-bold mb-4">How it Works</h2>
          <p className="text-text-muted">Start tracking in less than 30 seconds.</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
          <div className="hidden md:block absolute top-12 left-0 w-full h-0.5 bg-gradient-to-r from-transparent via-border-dark to-transparent z-0"></div>
          <div className="relative z-10 flex flex-col items-center text-center">
            <div className="size-20 rounded-2xl bg-background-dark border-2 border-primary text-primary flex items-center justify-center text-2xl font-bold mb-6 shadow-lg shadow-primary/10">
              1
            </div>
            <h3 className="text-white text-lg font-bold mb-3">Export UPI Statement</h3>
            <p className="text-text-muted text-sm px-4">Request your UPI transaction statement from your payment app or bank.</p>
          </div>
          <div className="relative z-10 flex flex-col items-center text-center">
            <div className="size-20 rounded-2xl bg-background-dark border-2 border-border-dark text-white flex items-center justify-center mb-6">
              <svg className="w-10 h-10" fill="currentColor" viewBox="0 0 24 24">
                <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/>
              </svg>
            </div>
            <h3 className="text-white text-lg font-bold mb-3">Import PDF Securely</h3>
            <p className="text-text-muted text-sm px-4">Upload the PDF to UPI Trackr. We process it locally on your device with no upload to servers.</p>
          </div>
          <div className="relative z-10 flex flex-col items-center text-center">
            <div className="size-20 rounded-2xl bg-background-dark border-2 border-border-dark text-white flex items-center justify-center mb-6">
              <svg className="w-10 h-10" fill="currentColor" viewBox="0 0 24 24">
                <path d="M21 8c-1.45 0-2.26 1.44-1.93 2.51l-3.55 3.56c-.3-.09-.74-.09-1.04 0l-2.55-2.55C12.27 10.45 11.46 9 10 9c-1.45 0-2.27 1.44-1.93 2.52l-4.56 4.55C2.44 15.74 1 16.55 1 18c0 1.1.9 2 2 2 1.45 0 2.26-1.44 1.93-2.51l4.55-4.56c.3.09.74.09 1.04 0l2.55 2.55C12.73 16.55 13.54 18 15 18c1.45 0 2.27-1.44 1.93-2.52l3.56-3.55c1.07.33 2.51-.48 2.51-1.93 0-1.1-.9-2-2-2z"/>
                <path d="M15 9l.94-2.07L18 6l-2.06-.93L15 3l-.92 2.07L12 6l2.08.93z"/>
                <path d="M3.5 11L4 9l2-.5L4 8l-.5-2L3 8l-2 .5L3 9z"/>
              </svg>
            </div>
            <h3 className="text-white text-lg font-bold mb-3">View Unified Insights</h3>
            <p className="text-text-muted text-sm px-4">Get comprehensive analytics on your spending with detailed breakdowns and visual reports.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
